{
    "coordinates": [
        29.082009163316727,
        69.16344391234625
    ],
    "tooltip": "Bugti Hills",
    "title": "Bugti Hills",
    "country": "Pakistan",
    "period": "Paleogene",
    "alt": "TODO"
}